import { NgModule } from '@angular/core';

import { BoolToStringPipe } from './bool-to-string.pipe';
import { ConfigValueToStringPipe } from './config/config-value-to-string.pipe';
import { LangToStringPipe } from './lang-to-string.pipe';
import { ObjectInArrayPipe } from './object-in-array.pipe';
import { RoundPipe } from './round.pipe';
import { TextAreaToHtmlPipe } from './textArea-to-html.pipe';


const pipes = [
    BoolToStringPipe,
    ConfigValueToStringPipe,
    RoundPipe,
    ObjectInArrayPipe,
    LangToStringPipe,
    TextAreaToHtmlPipe
];

@NgModule({
    imports: [
    ],
    declarations: [
        ...pipes
    ],
    exports: [
        ...pipes,
    ],
    providers: [
        ObjectInArrayPipe
    ],
})
export class SharedPipesModule {
}
